module.exports = __webpack_public_path__ + "ba206803d9022851c29a5afe0c5d9bc2.png";